module.exports = __webpack_public_path__ + "img/part_6_3.ed71134a.png";